module.exports = __webpack_public_path__ + "static/media/flights-icon-blue.e362ca4f.PNG";